<div class="card-body">
    <div id="apex-stacked-bar-chart"></div>
</div>